import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';

// 原因：
// 多次点击跳转同一个路由是不被允许的
//push
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
//replace
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
};

Vue.use(Router);

const mainRoute = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
      name: 'Index',
      component: Index,
    },
    {
      path: '/index',
      name: 'Index',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import("@/views/Home")
        },
        {
          path: '/product',
          name: 'Product',
          component: () => import("@/views/Product")
        },
        {
          path: '/about',
          name: 'About',
          redirect: '/aboutus',
          component: () => import("@/views/About"),
          children: [
            {
              path: '/aboutus',
              name: 'AboutUs',
              component: () => import("@/views/About/AboutUs")
            },
            {
              path: '/dynamics',
              name: 'dynamics',
              component: () => import("@/views/About/dynamics")
            },
            {
              path: '/certificate',
              name: 'certificate',
              component: () => import("@/views/About/certificate")
            },
            {
              path: '/contact',
              name: 'contact',
              component: () => import("@/views/About/contact")
            },
            {
              path: '/dynamicSidebar',
              name: 'dynamicSidebar',
              component: () => import("@/views/About/dynamicSidebar")
            }
          ]
        },
        {
          path: '/service',
          name: 'Service',
          component: () => import("@/views/service")
        },
 {
          path: '/searchResult',
          name: 'searchResult',
          component: () => import("@/views/searchResult")
        }
      ]
    }
  ],
})

export default mainRoute;



// WEBPACK FOOTER //
// ./src/router/index.js